export interface Permission {
    _id?: string;
    name?: string;
    resource?: string;
    action?: {
        label: string;
        value: string;
    }
};

export interface ValidPermission {
    _id: string;
    name: string;
    resource: string;
    action: {
        label: string;
        value: string;
    }
};

const isNotEmpty = (val: any): boolean => val !== null && val !== undefined;

export const isValidPermission = (perm: Permission): perm is ValidPermission => {
    return perm && isNotEmpty(perm._id) && isNotEmpty(perm.name) && isNotEmpty(perm.resource) && isNotEmpty(perm.action);
}
